import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import * as colors from '../../../common/styles/colors';
import { ButtonPrimary, Icon } from '../../../common/components';
import moment from 'moment';
import { useAuthState } from '../../../providers/authProvider';
import { downloadPdfReport } from '../../../common/api/ersGatewayAdapterApi';
import { TagManager } from '../../utils/analytics/TagManager';
import { isTpiUser } from '../../../helpers/tpiUser';

type InvoiceDownloadSuccessPdfModalProps = {
  show: boolean;
  onHide: () => void;
  onError: () => void;
  messagevalues: Messages.IMessagesValues;
};

const defaultProps = {
  show: true,
};

const InvoiceDownloadSuccessPdfModalWrapper = styled.div``;

export const InvoiceDownloadSuccessPdfModal = (props: InvoiceDownloadSuccessPdfModalProps) => {
  const authContext = useAuthState();
  const claims = authContext.getClaims();

  const obj = props.messagevalues.json;

  const requestId = obj.RequestId;
  const accountReference = obj.AccountReference;
  const requestDateTime = moment(obj.RequestDateTime);

  const title = 'Invoice download success PDF format';
  const messageTop = `The data you requested for account ${accountReference} on ${requestDateTime.format(
    'DD MMM YYYY'
  )} is now ready to download.`;

  const handleDownloadPDF = (e: any) => {
    e.preventDefault();

    TagManager.pushData({
      event: "Download Invoice PDF's",
      userType: isTpiUser() ? 'TPI User' : 'Customer',
      customerAccountReference: isTpiUser() ? `${accountReference}/${claims.tpiReferenceId}` : `${accountReference}`,
    });

    const result = downloadPdfReport(process.env.REACT_APP_API_URL, authContext, requestId);
    result
      .then((result: any) => {
        props.onHide();
      })
      .catch((error: any) => {
        props.onError();
      });
  };

  return (
    <InvoiceDownloadSuccessPdfModalWrapper>
      <Modal.Header style={{ justifyContent: 'center', textAlign: 'center' }}>
        <Modal.Title>
          <span className='pr-4 float-left'>
            <Icon color={colors.draxBtn} size={50} icon='download2' />
          </span>
          <div className='text-center'>{title}</div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ justifyContent: 'center', textAlign: 'center' }}>
        <p>{messageTop}</p>
      </Modal.Body>
      <Modal.Footer className='p-0'>
        <div className='d-flex justify-content-end'>
          <ButtonPrimary className='m-0' title="Download PDF's" onClick={handleDownloadPDF} />
        </div>
      </Modal.Footer>
    </InvoiceDownloadSuccessPdfModalWrapper>
  );
};

InvoiceDownloadSuccessPdfModal.defaultProps = defaultProps;
